/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum IntegratedToolName {
    Anomaly_Detector = 'Anomaly_Detector',
    AppDynamics = 'AppDynamics',
    App_Insights = 'App_Insights',
    Azure_Devops = 'Azure_Devops',
    Azure_Security_Graph = 'Azure_Security_Graph',
    Azure_Sentinel = 'Azure_Sentinel',
    Corestack = 'Corestack',
    DockerHub = 'DockerHub',
    ElasticSearch = 'ElasticSearch',
    Freshservice = 'Freshservice',
    GitHub = 'GitHub',
    JIRA_DataCenter = 'JIRA_DataCenter',
    JIRA_ServiceDesk = 'JIRA_ServiceDesk',
    JIRA_ServiceManagement = 'JIRA_ServiceManagement',
    Jenkins = 'Jenkins',
    Logstash = 'Logstash',
    Microsoft_Teams = 'Microsoft_Teams',
    Nagios = 'Nagios',
    Newrelic = 'Newrelic',
    Prometheus = 'Prometheus',
    Qualys = 'Qualys',
    RedHat_Satellite = 'RedHat_Satellite',
    ServiceNow = 'ServiceNow',
    TCL_ITSM = 'TCL_ITSM',
    Tenable_Nessus = 'Tenable_Nessus',
    ZOHO_ServiceDesk = 'ZOHO_ServiceDesk',
    Zabbix = 'Zabbix'
}
